import { 
    addDataFactory,
    IPlotData as ICorePlotData, 
    createPlotData as createCorePlotData, 
    ISourceData as ICoreSourceData, 
    createData as createCoreData,
} from "../../core";
import { IDashboardSharedViewModel, KeyedDimension } from "../../common/plotdata/viewModel"
import { boolOptions, IDashboardViewModel } from "./viewModel";

export { boolOptions };

/**
 * Sort asc
 * @param a 
 * @param b 
 */
export const sort = (_: ISourceData, a: string, b: string): number => {
    //Alphabetically by key (name)
    return ((a < b) ? -1 : ((a > b) ? 1 : 0));
};

/**
 * Plot data source
 */
export type IPlotData = ICorePlotData;

/**
 * Raw data source. Used to shape and accumulate.
 */
export type ISourceData = ICoreSourceData;

/**
 * Create a new plot data object.
 */
export const createPlotData = createCorePlotData;

/**
 * Create a new source data object
 */
export const createData = createCoreData;



/**
 * 
 * @param age Convert raw age to enum
 */
export const toYesNo = (bool: number): KeyedDimension => {
    if (bool == 1) {
        return boolOptions.y;
    } else if (bool == 0) {
        return boolOptions.n;
    } else return boolOptions.unknown;
};

/**
 * Accumulate the vm value into the source data object.
 * 
 * @param vm source view model
 * @param into data object to accumulate into
 */
export const addData = addDataFactory((vm: IDashboardViewModel) => vm.youthHadTreatment.name);
